import {
  selectUI,
  titleUI,
} from '@department-of-veterans-affairs/platform-forms-system/web-component-patterns';

import {
  stateLabels,
  stateSelectSchema,
} from '../../schema-helpers/state-select';

const pageTitle = 'State of facility';

const stateOfFacilityPage = {
  uiSchema: {
    ...titleUI(pageTitle),
    stateOfTheFacility: selectUI({
      title: 'Select state',
      labels: stateLabels,
      errorMessages: {
        required: 'Select state of facility',
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['stateOfTheFacility'],
    properties: {
      stateOfTheFacility: stateSelectSchema,
    },
  },
  title: pageTitle,
};

export default stateOfFacilityPage;
